var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPiTears(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140.893,
    height: 285.092,
    viewBox: "0 0 140.893 285.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.537,
    y1: -1.644,
    x2: 3.007,
    y2: -1.216,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3.171,
    y1: 3.963,
    x2: 4.195,
    y2: 4.216,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#7fbfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#79bbde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#6bb1d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#53a0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#3189c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.17,
    y1: 4.675,
    x2: 4.204,
    y2: 4.893,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(-1529.078 -629.934)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 70.447,
    cy: 6.646,
    rx: 70.447,
    ry: 6.646,
    transform: "translate(1529.078 901.734)",
    fill: "#707070",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pi_19",
    "data-name": "Pi 19",
    transform: "translate(1386.216 579.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M268.153,292.1l.043.281c.256,1.7.424,3.4.509,5.074a52.063,52.063,0,0,1-40.205,53.4.018.018,0,0,1-.012.008q-1.979.457-4.024.768A51.949,51.949,0,0,1,181.1,338.134c-.4-.377-.787-.754-1.176-1.139a52.073,52.073,0,0,1-2.162-71.416q1.191-1.349,2.476-2.605a52.1,52.1,0,0,1,54.351-11.744c.27.1.541.2.807.308a50.77,50.77,0,0,1,5.182,2.318.331.331,0,0,1,.061.035A52.236,52.236,0,0,1,246.3,257.3a.143.143,0,0,1,.041.025,52.031,52.031,0,0,1,18.2,22.237c.039.094.085.193.125.293a52.211,52.211,0,0,1,3.39,11.7c.034.182.06.359.088.541Z",
    transform: "translate(-2.41 -22.556)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M268.766,296.034l.015.1q.368,2.508.494,4.976a89.948,89.948,0,0,0-10.172-1A91.012,91.012,0,0,0,211.73,311.1c-7.736,4.2-21.029,11.612-29.772,26.841-.544.943-1.024,1.85-1.462,2.715a51.843,51.843,0,0,1-10.483-14.989,97.446,97.446,0,0,1,19.5-20.947s16.475-13.124,38.051-18.7c1.092-.282,2.285-.563,2.285-.563a99.932,99.932,0,0,1,23.216-2.85c2.164,0,3.753.077,4.646.129,2.744.167,5.243.445,7.454.766.032,0,.058.01.083.012a51.981,51.981,0,0,1,3.433,11.979c.034.182.06.359.088.542Z",
    transform: "translate(-3.023 -26.492)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M257.229,259.042a.147.147,0,0,0-.035-.033c-1.81-1.833-3.462-3.335-4.83-4.517a.351.351,0,0,0-.053-.046c-.287-.253-.564-.491-.828-.711-.841-.705-1.542-1.267-2.206-1.727-.012-.007-.024-.02-.035-.027a11.075,11.075,0,0,0-1.516-.883,9.37,9.37,0,0,0-1.132-.482,12.308,12.308,0,0,0-1.93-.568h-.012a4.6,4.6,0,0,0-1.231-.081,4.031,4.031,0,0,0-1.012.18,5.718,5.718,0,0,0-3.585,3.718c-.319,1.093-.665,2.214-1.043,3.347-.045.133-.084.267-.129.406q-.589,1.762-1.215,3.441c-.044.127-.089.242-.132.35,0,.012-.008.024-.008.036q-1.038,2.754-2.14,5.251v.006c-1.606,2.766-2.967,5.093-3.991,6.842-2.435,4.156-3.009,5.1-4.086,6.3a23.109,23.109,0,0,1-6.645,4.873c-5.7,3.2-8.566,4.824-11.322,3.839-1.17-.417-6.819-2.894-7.012-2.819a.9.9,0,0,1-.127.048c-.069.02-.133.048-.2.074-.058-.072-.115-.136-.173-.208a42.2,42.2,0,0,1-6.067-10.411l-.016-.038a89.955,89.955,0,0,1-4.857-15.52.244.244,0,0,1,0-.025c-.543-2.467-.944-4.733-1.2-6.627-.008-.068-.016-.137-.024-.212-1.251-9.459-.789-24.158-.766-24.953.131-4.31.666-9.905.743-11.785a13.948,13.948,0,0,1,.2-1.971s.084-.57.212-1.05a9.691,9.691,0,0,1,2.09-3.814,18.174,18.174,0,0,1,3.674-3.238,21.823,21.823,0,0,1,3.6-2c5.864-2.382,12.851-2.893,19.959-3.186,6.936-.285,16.386-.468,25.151,1.792a14.66,14.66,0,0,1,7.329,4.056,14.43,14.43,0,0,1,3.369,6.511,112.943,112.943,0,0,1,3.147,23.769c.1,9.8.1,17.47.092,22.09Z",
    transform: "translate(-5.023 -17.155)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M280.74,158.545a15.563,15.563,0,0,1-4.293,10.829,14.945,14.945,0,0,1-5.455,3.581A15.511,15.511,0,0,1,265.753,174c-16.868,1.4-34.895,2.339-53.954,2.584-17.663.23-34.447-.16-50.242-.979a15.476,15.476,0,0,1-4.411-.612,15.016,15.016,0,0,1-6.418-3.681c-.221-.211-.431-.433-.64-.663a15.161,15.161,0,0,1-3.984-10.032c-1.427-14.616-2.39-30.487-2.586-47.462-.181-15.417.289-29.924,1.189-43.4A15.563,15.563,0,0,1,149,58.925,15.191,15.191,0,0,1,159.694,54.3a405.461,405.461,0,0,1,49.475-4.109h.006c.248-.01.5-.013.743-.017A405.763,405.763,0,0,1,263.891,52.7a15.691,15.691,0,0,1,7.564,1.89,14.62,14.62,0,0,1,3.265,2.4,15.211,15.211,0,0,1,4.623,10.694,339.081,339.081,0,0,1,3.728,44.016,339.232,339.232,0,0,1-2.33,46.843Z",
    transform: "translate(0 0)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M196.869,286.294a18.253,18.253,0,0,0,6.148,5.672,17.972,17.972,0,0,0,9.561,2.316c6.647-.386,11.041-5.013,15.309-9.507a45.7,45.7,0,0,0,8.028-11.686,72.593,72.593,0,0,1-9.15,16.3,31.023,31.023,0,0,1-6.217,6.292c-2.427,1.824-4.6,3.41-7.725,3.651a12.067,12.067,0,0,1-6.5-1.491c-4.39-2.221-6.669-6.322-8.316-9.288-.524-.943-.9-1.741-1.138-2.257Z",
    transform: "translate(-6.083 -25.407)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 8.178,
    cy: 12.659,
    rx: 8.178,
    ry: 12.659,
    transform: "translate(230.903 193.996) rotate(-5.801)",
    fill: "#c8ced6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M274.84,164.66a15.966,15.966,0,0,1-2.811,9.2,15.511,15.511,0,0,1-5.239,1.042c-16.868,1.4-34.895,2.339-53.954,2.584q-9.366.12-18.4.019c-.019,0-.043,0-.062,0q-16.482-.181-31.783-1a15.476,15.476,0,0,1-4.411-.612,15.433,15.433,0,0,1-3.306-9.391c-1.289-14.137-2.166-29.479-2.36-45.9-.175-14.49.2-28.144.944-40.867l.745-.066a13.241,13.241,0,0,0,9.523-4.459,15.8,15.8,0,0,0,3.814-10.463c.042-.38.083-.761.125-1.147a333.627,333.627,0,0,1,91.789-1.335c.011.13.022.254.033.385a15.29,15.29,0,0,0,4.027,10.226c.035.045.069.078.1.118a13.257,13.257,0,0,0,9.657,4.16l.265.016a354.873,354.873,0,0,1,3.325,42.194,355.274,355.274,0,0,1-2.026,45.293Z",
    transform: "translate(-1.025 -1.097)",
    fill: "#353f44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M272.216,297.593l-.017.283c-.1,1.717-.292,3.41-.559,5.068a52.062,52.062,0,0,1-50.449,43.849c4.116-1.364,28.463-9.888,37.441-33.449a53.236,53.236,0,0,0,3.286-13.787,40.142,40.142,0,0,0-1.824-17.147c-.127-.36-.268-.77-.439-1.225a29.073,29.073,0,0,0-10.041-14.067,25.636,25.636,0,0,0-5.307-2.959A55.383,55.383,0,0,1,234,279.209a41.575,41.575,0,0,1-12.492,8.814,39.477,39.477,0,0,1-5.113,1.9c.695-.452,1.416-.946,2.153-1.489a.321.321,0,0,0,.058-.04,48.886,48.886,0,0,0,6.074-5.242c.733-.747,1.006-1.044,1.115-1.168a19.009,19.009,0,0,0,1.957-2.684c2.933-4.771,4.408-7.174,4.89-8.073a96.65,96.65,0,0,0,4.555-9.786.071.071,0,0,1,0-.019.138.138,0,0,0,0-.019c.043-.109.088-.223.132-.35.329-.844.765-2.023,1.215-3.441.045-.139.084-.273.129-.406,1.272-4.087,1.236-5.423,2.586-6.41a4.95,4.95,0,0,1,3.052-.835c.463,0,.887.047,1.231.081h.012l.025,0a7.868,7.868,0,0,1,2.313.579,8.344,8.344,0,0,1,2.241,1.352c.012.007.023.02.035.027.151-.757.364-1.936.556-3.382a61.54,61.54,0,0,0-2.275-25.946c-2.048-6.8-3.226-10.505-6.9-13.044-2.158-1.5-4.167-1.883-9.455-2.493-10.257-1.188-15.385-1.782-23.507-1.7-6.1.064-10.331.352-13.111.567a21.825,21.825,0,0,1,3.6-2c5.864-2.382,12.851-2.893,19.959-3.186,6.936-.285,16.386-.468,25.151,1.792a14.66,14.66,0,0,1,7.329,4.056,14.43,14.43,0,0,1,3.369,6.511,112.943,112.943,0,0,1,3.147,23.769c.1,9.8.1,17.47.092,22.09A52.032,52.032,0,0,1,271.3,284.582c.03.008.054.022.079.029a51.976,51.976,0,0,1,.861,12.431c-.005.185-.016.363-.027.548Z",
    transform: "translate(-5.926 -17.155)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M297.137,159.123a15.563,15.563,0,0,1-4.293,10.829,14.944,14.944,0,0,1-5.455,3.581,71.712,71.712,0,0,0,4.352-12.116s.595-2.275,1.047-4.65c2.605-13.568,1.469-52.122,1.469-52.122-.343-11.6-2.074-23.13-2.293-34.731a29.66,29.66,0,0,0-1.629-9.432,28.682,28.682,0,0,0-2.484-5.308,14.619,14.619,0,0,1,3.265,2.4,15.21,15.21,0,0,1,4.624,10.694,339.081,339.081,0,0,1,3.728,44.016,339.227,339.227,0,0,1-2.33,46.843Z",
    transform: "translate(-16.397 -0.578)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M280.223,166.566a15.966,15.966,0,0,1-2.811,9.2,15.511,15.511,0,0,1-5.239,1.042c-16.868,1.4-34.895,2.339-53.954,2.584q-9.366.12-18.4.019a268.851,268.851,0,0,0,29.717-2.627c17.966-2.6,27.064-4.005,32.607-9.562,4.951-4.958,5.9-15.044,7.805-35.221a246.619,246.619,0,0,0,.341-45c-.41-4.664-.914-8.784-1.393-12.216.035.045.069.078.1.118a13.257,13.257,0,0,0,9.657,4.16l.265.016a354.873,354.873,0,0,1,3.325,42.194,355.274,355.274,0,0,1-2.026,45.293Z",
    transform: "translate(-6.42 -2.813)",
    fill: "#15192f",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M200.969,290.395a23.15,23.15,0,0,1-3.236-3.11,31.913,31.913,0,0,1-3.923-6.224,33.129,33.129,0,0,1-1.886-4.076l0-.011c-.727-1.914-2.17-6.406-4.872-15.558a.24.24,0,0,1,0-.025,53.351,53.351,0,0,0-6.1,6.013A61.952,61.952,0,0,0,169.8,288.141c-2.975,10.285-1.91,24.149,4.161,38.069-.313-.451-.612-.9-.913-1.358a52.072,52.072,0,0,1,12.766-70.3c-1.251-9.459-.789-24.158-.766-24.953.131-4.31.666-9.905.743-11.785a13.951,13.951,0,0,1,.2-1.971,171.077,171.077,0,0,0,2.788,36.676,158.959,158.959,0,0,0,7.223,26.041q1.651,4.427,3.469,8.53.732,1.684,1.493,3.3Z",
    transform: "translate(-2.411 -18.885)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M202.341,65.682c-6.292.007-13.045.291-20.192.976q-5.253.5-10.14,1.217a12.872,12.872,0,0,1-.612,7.1c-1.872,4.7-6.682,7.936-12.415,8.584-1.023,9.344-1.784,19.261-2.161,29.7a408.826,408.826,0,0,0,1.546,53.172,352.006,352.006,0,0,1,2.435-40.3c3.3-27.911,7.547-35.079,9.233-37.7,3.189-4.95,11.873-16.353,32.307-22.757Z",
    transform: "translate(-1.49 -1.776)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M209.169,50.208c-22,2.451-38.222,4.356-42.759,5.008-.448.066-1.863.276-3.694.722A25.06,25.06,0,0,0,154.47,59.1a15.707,15.707,0,0,0-5.662,5.878c-.53,1.006-1.187,2.572-1.71,7.038a44.4,44.4,0,0,0-.4,9.674c.393,6.065-.573,5.3-.613,34.377,0,0-.034,25.813,1.663,42.4a66.615,66.615,0,0,0,2.34,12.187,15.161,15.161,0,0,1-3.984-10.032c-1.427-14.616-2.39-30.487-2.586-47.462-.181-15.417.289-29.924,1.189-43.4A15.563,15.563,0,0,1,149,58.939a15.191,15.191,0,0,1,10.694-4.623,405.461,405.461,0,0,1,49.475-4.109Z",
    transform: "translate(0 -0.013)",
    fill: "#fff",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 17.905,
    height: 12.789,
    rx: 4.306,
    transform: "translate(198.428 200.098) rotate(-0.348)",
    fill: "#2eb3bd",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M218.954,224.272a.682.682,0,0,0,.678-.686l-.005-.837a.682.682,0,0,0-.686-.678l-7.633.046a.682.682,0,0,0-.678.686l.005.837a.682.682,0,0,0,.686.678l1.065-.006.032,5.24a.55.55,0,0,0,.554.547l.478,0a.55.55,0,0,0,.547-.554l-.032-5.24,2.788-.017.032,5.235a.556.556,0,0,0,.56.553h.019l.447,0,1.157-.007a.533.533,0,0,0,.53-.536l0-.513a.533.533,0,0,0-.536-.53l-.457,0a.167.167,0,0,1-.1-.055.17.17,0,0,1-.041-.123q-.012-2.016-.025-4.032l.622,0Z",
    transform: "translate(-7.651 -19.594)",
    fill: "#139093"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 45.52,
    height: 54.088,
    rx: 12.296,
    transform: "translate(162.047 82.025) rotate(-1.306)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 45.52,
    height: 53.187,
    rx: 12.296,
    transform: "translate(217.849 82.476) rotate(-1.306)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 10.439,
    cy: 10.439,
    r: 10.439,
    transform: "translate(168.373 85.396)",
    fill: "#daeffd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 4.725,
    cy: 4.725,
    r: 4.725,
    transform: "translate(169.36 109.325)",
    fill: "#daeffd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 9.777,
    cy: 9.777,
    r: 9.777,
    transform: "translate(223.6 85.152)",
    fill: "#daeffd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 4.426,
    cy: 4.426,
    r: 4.426,
    transform: "translate(224.525 107.563)",
    fill: "#daeffd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M171.74,215.22c6.046,2.569,14.43-5.742,18.785-10.072a81.314,81.314,0,0,0,11.427-14.408c.8-1.287,1.515-2.563,2.142-3.791.074-.135.143-.261.2-.393.081-.161.157-.315.231-.474.146-.307.287-.605.422-.9.1-.229.208-.463.3-.7.073-.172.144-.344.211-.514.13-.322.247-.648.364-.973,1-2.772,1.267-5.111.535-6.649a3.025,3.025,0,0,0-.5-.755c-2.268-2.518-8.315-.622-12.361.646a28.144,28.144,0,0,0-3.219,1.226c-.381.171-.756.341-1.115.526a27.232,27.232,0,0,0-2.837,1.622,55.685,55.685,0,0,0-8.072,6.707,47.206,47.206,0,0,0-7.971,9.706c-.466.748-.907,1.522-1.337,2.326a23.735,23.735,0,0,0-2.319,5.725,8.1,8.1,0,0,0-.21,2.954c.367,3.165,2.317,6.917,5.311,8.2Z",
    transform: "translate(-2.608 -14.157)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M188.207,188.361c2.205,4.393,10.261,3.57,11.623,3.433a17.5,17.5,0,0,0,2.943-.567c.613-.174,1.147-.363,1.6-.537.8-1.287,1.515-2.563,2.142-3.791.074-.135.143-.261.2-.393.081-.161.157-.315.231-.474.146-.307.287-.605.422-.9.1-.229.208-.463.3-.7.073-.172.144-.344.211-.514.13-.322.247-.648.364-.973.814-2.328,1.3-4.879.49-6.659a3.236,3.236,0,0,0-.452-.745c-2.8-3.505-11.829-.241-12.479,0a20.448,20.448,0,0,0-2.943,1.379,14.562,14.562,0,0,0-1.272,1.023,12.614,12.614,0,0,0-3.219,4.441,7.216,7.216,0,0,0-.173,5.984Z",
    transform: "translate(-5.031 -14.109)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M171.74,216.841c6.046,2.569,14.43-5.742,18.785-10.072a81.315,81.315,0,0,0,11.427-14.408c.8-1.287,1.515-2.563,2.142-3.791-1.3,1.531-2.546,2.978-3.745,4.327q-.621.71-1.232,1.38-3.85,4.257-7.061,7.29c-4.957,4.684-7.825,7.368-11.476,9.663-1.574,1-3.464,2.477-6.085,2.4a8.861,8.861,0,0,1-4.359-1.5,9.426,9.426,0,0,1-3.5-6.435,8.1,8.1,0,0,0-.21,2.954c.367,3.165,2.317,6.917,5.311,8.2Z",
    transform: "translate(-2.609 -15.777)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M170.8,195.971a94.879,94.879,0,0,1,13.426-12.006q1.158-.856,2.234-1.588c7.434-5.095,12.006-6.223,15.923-6.357a23.954,23.954,0,0,1,4.443.263l.046.01a3.025,3.025,0,0,0-.5-.755c-2.8-3.505-11.829-.241-12.479,0a20.448,20.448,0,0,0-2.943,1.379,14.559,14.559,0,0,0-1.272,1.023,27.23,27.23,0,0,0-2.837,1.621,55.686,55.686,0,0,0-8.072,6.708,47.206,47.206,0,0,0-7.971,9.706Z",
    transform: "translate(-3.113 -14.109)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M219.874,174.474a3.415,3.415,0,0,0-.257.335l-.036.056c-.856,1.2-.937,3.083-.417,5.392.032.16.07.326.108.486.019.061.032.129.051.2.069.277.145.554.227.825a.609.609,0,0,1,.025.08c.095.307.195.622.307.948.075.215.151.424.232.627.1.277.206.554.32.836.019.055.043.111.063.16.075.172.15.351.225.529.082.2.163.381.244.56.144.332.3.664.463,1,.5,1.069,1.068,2.17,1.691,3.283.879,1.573,1.857,3.183,2.915,4.773a81.141,81.141,0,0,0,7.874,10.12c4.158,4.513,12.172,13.189,18.324,10.889a6.191,6.191,0,0,0,1.143-.568,10.348,10.348,0,0,0,3.8-4.857,11.865,11.865,0,0,0,.725-2.532c.191-1.185.354-3.542-2.15-8.78a46.53,46.53,0,0,0-8.776-12.433,55.888,55.888,0,0,0-7.769-7.057,28.214,28.214,0,0,0-2.767-1.746c-.353-.195-.712-.385-1.083-.567a27.333,27.333,0,0,0-3.159-1.368c-3.992-1.443-9.95-3.608-12.321-1.189Z",
    transform: "translate(-8.586 -14.047)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M219.877,174.431a3.412,3.412,0,0,0-.257.335l-.036.056c-.892,1.374-.849,3.378-.417,5.392.032.16.07.326.108.486.019.061.032.129.051.2.069.277.145.554.227.825a.606.606,0,0,1,.025.08c.095.307.195.622.307.948.075.215.151.424.232.627.1.277.206.554.32.836.019.055.043.111.063.16.075.172.15.351.225.529.082.2.163.381.244.56.144.332.3.664.463,1,.5,1.069,1.068,2.17,1.691,3.283a17.525,17.525,0,0,0,4.491,1.3c1.364.2,9.368,1.373,11.772-2.92a6.111,6.111,0,0,0,.657-3.525,11.609,11.609,0,0,0-3.6-7.044,13.6,13.6,0,0,0-1.215-1.071,19.921,19.921,0,0,0-2.882-1.505c-.643-.268-9.514-3.919-12.465-.547Z",
    transform: "translate(-8.59 -14.005)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M219.874,174.431a3.415,3.415,0,0,0-.257.335l-.036.056c-.856,1.2-.937,3.083-.417,5.392.032.16.07.326.108.486.019.061.032.129.051.2.069.277.145.554.227.825a.609.609,0,0,1,.025.08c.095.307.195.622.307.948.075.215.151.424.232.627.1.277.206.554.32.836.019.055.043.111.063.16.075.172.15.351.225.529.082.2.163.381.244.56.144.332.3.664.463,1a14.08,14.08,0,0,1-.733-8.906,3.691,3.691,0,0,1,1.362-2.2c1.474-.99,3.624-.225,5.343.517a36.959,36.959,0,0,1,10.045,6.247q1.358,1.3,2.593,2.482c8.473,8.125,12.915,12.734,15.347,19.195a38.54,38.54,0,0,1,1.79,6.31,11.865,11.865,0,0,0,.725-2.532c.19-1.185.354-3.542-2.15-8.78a46.531,46.531,0,0,0-8.776-12.433,55.887,55.887,0,0,0-7.769-7.057,28.214,28.214,0,0,0-2.767-1.746,13.6,13.6,0,0,0-1.215-1.071,19.92,19.92,0,0,0-2.882-1.505c-.643-.268-9.514-3.919-12.465-.547Z",
    transform: "translate(-8.586 -14.005)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M226.958,197.286a81.142,81.142,0,0,0,7.874,10.12c4.158,4.513,12.172,13.189,18.324,10.889a6.189,6.189,0,0,0,1.143-.568,24.864,24.864,0,0,1-4.552-1.125c-4.27-1.5-7.12-3.847-15.048-11.6-2.295-2.243-4.895-4.823-7.742-7.716Z",
    transform: "translate(-9.511 -16.77)",
    fill: "#fff",
    opacity: 0.49
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiTears);
export default __webpack_public_path__ + "static/media/pi-tears.df12a8988b7328d3e6db65113dd9e972.svg";
export { ForwardRef as ReactComponent };